import React from 'react';
import { Dispatch } from 'redux';
import { AppState } from 'acscp/store';
import style from './client.module.scss';
import { CustomerContactDetailsRequest } from 'acscp/api/requests';
import { FetchRequest } from 'acscp/actions';
import { connectWithRequests } from 'acscp/store/helpers/connectWithRequests';
import { PresentationComponentBase } from 'acscp/components/presentationComponentBase';

interface ClientStateProps {
    contactName?: string;
}

interface ClientDispatchProps {
    fetchCustomerContactDetails: () => void;
}

export class ClientPresentational extends PresentationComponentBase<{},
    ClientStateProps, ClientDispatchProps, {}> {

    componentDidMount(): void {
        if (!this.props.contactName) {
            this.props.fetchCustomerContactDetails();
        }
    }

    render(): JSX.Element {
        return (
            <div className={style.Client}>{this.props.contactName}</div>
        );
    }
}

function mapStateToProps(state: AppState, ownProps: {}): ClientStateProps {
    return {
        contactName: state.customerContact.customer && state.customerContact.customer.contactName
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: {}): ClientDispatchProps {
    return {
        fetchCustomerContactDetails: () => dispatch(new FetchRequest(new CustomerContactDetailsRequest()))
    };
}

export const Client = connectWithRequests(mapStateToProps, mapDispatchToProps)
    (ClientPresentational);
